import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { BladeCal } from '@/constants/blade';

export default function Progress({ calcObj }: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('bladecalculator');
    const { currentStep, check5, check4, currentPage } = calcObj;
    return (
        <div className={`progress ${css.progress} ${currentPage === BladeCal.Step5 && !check4 ? 'hide-2' : ''}`}>
            <div className={`bg-lines active-${currentPage === BladeCal.Step5 && !check5 ? 4 : currentPage === BladeCal.Step5 && check5 ? 5 : currentStep}`}>
                <span className={`line1 line`}></span>
                <span className={`line2 line`}>
                    <span className={`line2-sub`}></span>
                    <span className={`line2-sub`}></span>
                    <span className={`line2-sub`}></span>
                </span>
                <span className={`line3 line`}></span>
            </div>
            <div className="text-box">
                <span className="line-text text1">{t('detail.calculator_progress_text1')}</span>
                <span className="line-text text2">{t('detail.calculator_progress_text2')}</span>
                <span className="line-text text3">{t('detail.calculator_progress_text3')}</span>
            </div>
        </div>
    );
}
